/**
 * Données livret interactif Formation 125 (7 h).
 * 5 chapitres cochés : Bienvenue · Comprendre · Maîtriser · Circuler · Prêt.
 *
 * Chaque item est cochable (localStorage) et reflète un point clé à
 * valider par l'élève pendant sa formation.
 */
import { Sparkles, BookOpen, Flag, Bike, Trophy } from 'lucide-react';
import { PHASES_125 } from './formation125Progression';

// Liste plate des compétences de la trame 125 (pour LivretSessionRecap).
const COMPETENCES_125 = PHASES_125.flatMap(p =>
  (p.exercises || []).map(ex => ({ id: ex.id, title: ex.title, phaseId: p.id }))
);

export const LIVRET_125 = {
  storageKey: 'code2roues:livret-125:v1',
  // trameKey → utilisé par LivretSessionRecap pour lire les auto-évals
  trameKey: '125',
  competences: COMPETENCES_125,
  title: 'Livret Formation 125',
  subtitle: '7 h · Passerelle B → 125 cm³',
  trameTo: '/formation-125-progression',
  trameLabel: 'Trame pédagogique Formation 125',
  livretTo: '/livret-125',
  livretLabel: 'Livret Formation 125 interactif',
  chapters: [
    {
      id: 'cover',
      n: '',
      title: 'Bienvenue en formation 125',
      icon: Sparkles,
      color: '#e11d48',
      intro: 'Ce livret t\u2019accompagne pendant tes 7 heures de formation 125 cm³. Coche les cases au fur et à mesure des acquis, avec ton moniteur ou en révision.',
      profil: true,
      sections: [
        {
          title: 'Ce que tu vas apprendre',
          items: [
            'Comprendre les enjeux du 2-roues',
            'Maîtriser ta moto à basse et haute vitesse',
            'Circuler en sécurité sur route',
            'Anticiper les situations dangereuses',
            'Développer ton auto-évaluation',
          ],
        },
      ],
    },
    {
      id: 'comprendre',
      n: '01',
      title: 'Comprendre · Théorie (≈ 1 h à 1 h 30)',
      icon: BookOpen,
      color: '#0891b2',
      context: 'salle',
      sections: [
        {
          title: 'Aspects administratifs & équipements',
          items: [
            'Je connais les conditions légales de conduite du 125 (permis B + 7 h)',
            'Je sais rouler à l\u2019étranger avec ma formation',
            'Je porte un casque homologué correctement ajusté',
            'Je porte des gants CE homologués moto',
            'Je porte un blouson et chaussures adaptés',
            'Je fais mes vérifications avant chaque départ',
          ],
        },
        {
          title: 'Vulnérabilité & visibilité',
          items: [
            'Je connais les angles morts des autres véhicules',
            'Je sais comment me rendre visible',
            'J\u2019anticipe les défauts de perception des autres usagers',
            'J\u2019adopte une conduite défensive',
          ],
        },
        {
          title: 'Accidentologie & risques',
          items: [
            'Je connais les 7 accidents-types à moto',
            'Je connais la règle des 2 secondes',
            'Je sais adapter mes distances de sécurité',
            'Je connais les points clés des intersections et virages',
          ],
        },
      ],
    },
    {
      id: 'maitriser',
      n: '02',
      title: 'Maîtriser · Hors circulation (≈ 2 h 30 à 3 h)',
      icon: Flag,
      color: '#16a34a',
      context: 'plateau',
      sections: [
        {
          title: 'Bases',
          items: [
            'Découverte des commandes',
            'Position sur la moto',
            'Béquillage et déplacement moteur arrêté',
            'Démarrage et arrêt avec les 2 freins',
          ],
        },
        {
          title: 'Basse vitesse',
          items: [
            'Point de patinage maîtrisé',
            'Marche lente en ligne droite',
            'Braquage / huit à faible allure',
            'Montée de vitesse et rétrogradation',
            'Arrêt et départ en tournant',
            'Demi-tour à basse vitesse (G et D)',
          ],
        },
        {
          title: 'Compétences avancées',
          items: [
            'Contre-braquage compris et expérimenté',
            'Freinage d\u2019urgence contrôlé',
            'Évitement réalisé avec regard vers la sortie',
            'Conduite avec passager (communication + démarrage + arrêt)',
          ],
        },
      ],
    },
    {
      id: 'circuler',
      n: '03',
      title: 'Circuler · En route (≈ 3 h)',
      icon: Bike,
      color: '#ea580c',
      context: 'circulation',
      sections: [
        {
          title: 'Position et anticipation',
          items: [
            'Je me place au bon endroit dans la voie',
            'Je respecte mes distances de sécurité',
            'Je regarde loin et je prends mes informations',
          ],
        },
        {
          title: 'Manœuvres',
          items: [
            'Changement de direction complet (rétro → angle mort → cligno → action)',
            'Franchissement d\u2019intersection en sécurité',
            'Giratoire négocié sans hésitation',
            'Virages avec Voir → Placer → Tourner → Sortir',
            'Départ sur route ou insertion voie rapide',
          ],
        },
      ],
    },
    {
      id: 'pret',
      n: '04',
      title: 'Prêt à rouler seul ?',
      icon: Trophy,
      color: '#a855f7',
      sections: [
        {
          title: 'Auto-évaluation finale',
          items: [
            'Je me sens à l\u2019aise à basse vitesse',
            'Je maîtrise mon freinage d\u2019urgence',
            'Je gère les intersections avec confiance',
            'Je regarde loin et j\u2019anticipe',
            'Je connais mes limites et je les respecte',
            'Je suis prêt à rouler seul en toute sécurité',
          ],
        },
      ],
    },
  ],
};
